module.exports = __webpack_public_path__ + "e180f834b2c6db9214ff62735dbfb571.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Pachantiew/beijing.jpg
// module id = 640
// module chunks = 47